import axios from 'axios'
export default {
  namespaced: true,
  state: {
    feedbackConfiguration: {}
  },
  mutations: {
  },
  actions: {
    saveFeedback ({ commit }, feedbackInput) {
      return axios.post('Feedback/SaveFeedback', feedbackInput)
    }
  },
  getters: {
  }
}
